<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template #cell(specialPriceManageGroupName)="{ item }">
            <p
              class="m-0 underline"
              @click="editClose(item.specialPriceManageGroupId)"
            >
              {{ item.specialPriceManageGroupName }}
            </p>
          </template>

          <template #cell(effectiveDt)="{ item }">
            <p class="m-0">
              {{ $moment(item.effectiveDt).locale("th").format("Do/MM/YYYY") }}
            </p>
          </template>

          <template #cell(expiryDt)="{ item }">
            <p class="m-0">
              {{
                item.expiryDt
                  ? $moment(item.expiryDt).locale("th").format("Do/MM/YYYY")
                  : "-"
              }}
            </p>
          </template>

          <template #cell(isActive)="{ item }">
            <p
              class="m-0"
              :class="item.isActive == 1 ? 'text-success' : 'text-error'"
            >
              {{ item.isActive == 1 ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
            </p>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <Pagination
      @handleChangeTake="handleChangeTake"
      :pageOptions="pageOptions"
      :rows="rows"
      :filter="filter"
      @pagination="pagination"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  props: {
    filter: {
      required: false,
      type: Object,
    },
    pageOptions: {
      required: true,
      type: Array,
    },
    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
  },
  methods: {
    editClose(specialPriceManageGroupId) {
      this.$emit("editClose", specialPriceManageGroupId);
    },
    openModalConfirm(obj) {
      let { refId } = obj;

      this.$emit("getPaymentInfo", refId);
    },
    // handleDelete(item) {
    //   this.$emit("handleDelete", item);
    // },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
    },

    formatNumber(val) {
      return this.$services.utils.formatNumber(val);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--secondary-color);
  color: var(--font-color);
}
.color-red {
  color: #dc3545;
}
.color-green {
  color: #28a745;
}
.color-blue {
  color: lightcoral;
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}
</style>
